export class Partner {
  public constructor(
    public objectNumber: string,
    public changedTime: string,
    public changedBy: string,
    public partnerFunction: string,
    public counter: string,
    public partner: string,
    public vendorName: string,
    public createdDate: string,
    public createdTime: string,
    public createdBy: string,
    public changedDate: string
  ) {}
}
